<template>
  <v-card>
    <v-card-title class="headline colorHeadlineStandard" primary-title>
      {{ $tc('label.employee') }}
      <v-spacer />
      <v-icon large @click="$emit('closeDialog', true)">{{ mdiClose }}</v-icon>
    </v-card-title>
    <v-card-text class="pa-3">
      <v-form v-model="validForm" ref="employeeForm">
        <v-row>
          <v-col cols="6">
            <v-text-field
              :label="$t('label.name')"
              v-model="employee.name"
              maxlength="64"
              hide-details
              dense
              :rules="[ruleRequired]"
              v-on:blur="employee.name = employee.name.charAt(0).toUpperCase() + employee.name.slice(1)"
              autofocus
              :autocomplete="Math.random()"
              :name="Math.random()"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              :label="$t('label.surname')"
              v-model="employee.surname"
              maxlength="64"
              hide-details
              dense
              :rules="[ruleRequired]"
              v-on:blur="employee.surname = employee.surname.charAt(0).toUpperCase() + employee.surname.slice(1)"
              :autocomplete="Math.random()"
              :name="Math.random()"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="!$store.state.auth.settings.autoOrgID" cols="4">
            <v-text-field
              :label="$tc('label.employeeIdentifier')"
              v-model="employee.orgID"
              maxlength="64"
              hide-details
              dense
              :rules="[ruleRequired]"
              @click:append-outer="genOrgID"
              :append-outer-icon="mdiStar"
              :autocomplete="Math.random()"
              :name="Math.random()"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              :label="$tc('label.department', 2)"
              v-model="employee.department"
              maxlength="64"
              hide-details
              dense
              :autocomplete="Math.random()"
              :name="Math.random()"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              :label="$t('label.position')"
              v-model="employee.position"
              maxlength="64"
              hide-details
              dense
              :autocomplete="Math.random()"
              :name="Math.random()"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-text-field
              :label="$t('label.email')"
              v-model="employee.email"
              maxlength="64"
              hide-details
              dense
              :prepend-inner-icon="mdiEmail"
              v-on:blur="employee.email = employee.email.toLowerCase()"
              :autocomplete="Math.random()"
              :name="Math.random()"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              :label="$t('label.phone')"
              v-model="employee.phone"
              maxlength="64"
              hide-details
              dense
              :prepend-inner-icon="mdiPhoneClassic"
              :autocomplete="Math.random()"
              :name="Math.random()"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              :label="$t('label.mobile')"
              v-model="employee.mobile"
              maxlength="64"
              hide-details
              dense
              :prepend-inner-icon="mdiPhone"
              :autocomplete="Math.random()"
              :name="Math.random()"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-text-field
              :label="$t('label.floor')"
              v-model="employee.floor"
              maxlength="64"
              hide-details
              dense
              :autocomplete="Math.random()"
              :name="Math.random()"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              :label="$t('label.door')"
              v-model="employee.door"
              maxlength="64"
              hide-details
              dense
              :autocomplete="Math.random()"
              :name="Math.random()"
            />
          </v-col>
          <v-col cols="4">
            <v-select
              v-model.number="employee.area"
              :label="$tc('label.area')"
              :items="listAreas"
              item-text="name"
              item-value="id"
              :return-object="false"
              :rules="[ruleRequired]"
              hide-details
              dense
              :prepend-inner-icon="mdiHomeCity"
              :autocomplete="Math.random()"
              :name="Math.random()"
            />
          </v-col>
        </v-row>
        <v-row v-if="this.$store.state.auth.settings.planVisits">
          <v-col cols="4">
            <v-select
              v-model.number="employee.employeeGroup"
              :label="$tc('label.planningGroup')"
              :items="listEmployeeGroups"
              item-text="displayName"
              item-value="id"
              :menu-props="{ minWidth: '500' }"
              :return-object="false"
              append-icon="$dropdown"
              clearable
              hide-details
              dense
              :prepend-inner-icon="mdiAccountMultipleCheck"
              :autocomplete="Math.random()"
              :name="Math.random()"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              :label="$t('label.loginName')"
              v-model="employee.loginName"
              maxlength="128"
              hide-details
              dense
              :autocomplete="Math.random()"
              :name="Math.random()"
              :prepend-inner-icon="mdiFormTextbox"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              type="password"
              :label="$t('label.password')"
              v-model="employee.password"
              maxlength="64"
              hide-details
              dense
              autocomplete="new-password"
              :name="Math.random()"
              :prepend-inner-icon="mdiFormTextboxPassword"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea
              v-model="employee.note"
              name="input-7-1"
              :label="$t('label.note')"
              no-resize
              hide-details
              dense
              :autocomplete="Math.random()"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-divider />
    <v-card-actions
      v-if="
        ($store.state.auth.userSettings.accEmployees.write && employee.id == 0) ||
        ($store.state.auth.userSettings.accEmployees.update && employee.id > 0)
      "
    >
      <v-spacer />
      <v-btn color="colorSave" @click="dataSave">{{ $tc('btn.save') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import {
  mdiMagnify,
  mdiPen,
  mdiClose,
  mdiHomeCity,
  mdiAccountMultipleCheck,
  mdiStar,
  mdiEmail,
  mdiPhone,
  mdiPhoneClassic,
  mdiExport,
  mdiImport,
  mdiCloseThick,
  mdiCheckBold,
  mdiFormTextbox,
  mdiFormTextboxPassword,
} from '@mdi/js';

export default Vue.extend({
  name: 'dataEditEmployee',
  props: {
    openDialog: Boolean,
    selectedEmployee: Object,
  },
  data: () => ({
    dialogEdit: false,
    modalDelete: false,
    modalImport: false,
    validForm: false,
    listEmployeeGroups: [],
    listAreas: [],
    tableData: [],
    loaderStatus: false,
    search: '',
    employee: {
      id: 0,
      orgID: '',
      name: '',
      surname: '',
      loginName: '',
      password: '',
      department: '',
      position: '',
      floor: '',
      door: '',
      note: '',
      email: '',
      phone: '',
      mobile: '',
      employeeGroup: 0,
      area: 0,
    },
    mdiMagnify: mdiMagnify,
    mdiPen: mdiPen,
    mdiClose: mdiClose,
    mdiHomeCity: mdiHomeCity,
    mdiAccountMultipleCheck: mdiAccountMultipleCheck,
    mdiStar: mdiStar,
    mdiEmail: mdiEmail,
    mdiPhone: mdiPhone,
    mdiPhoneClassic: mdiPhoneClassic,
    mdiExport: mdiExport,
    mdiImport: mdiImport,
    mdiCloseThick: mdiCloseThick,
    mdiCheckBold: mdiCheckBold,
    mdiFormTextbox: mdiFormTextbox,
    mdiFormTextboxPassword: mdiFormTextboxPassword,
  }),
  watch: {
    selectedEmployee() {
      this.openDialogUpdate();
    },
  },
  computed: {
    ruleRequired() {
      return (v: any) => !!v || this.$i18n.t('msg.fieldIsMandatory');
    },
  },
  mounted() {
    this.openDialogUpdate();
  },
  methods: {
    openDialogUpdate() {
      this.listEmployeeGroupsLoad();
      this.listAreasLoad();
      this.selectedEmployee != undefined ? (this.employee = { ...this.selectedEmployee }) : this.dataNew();
    },
    dataNew() {
      const defaults: any = this.$options;
      this.employee = { ...defaults.data().employee };
      if (this.listAreas.length === 1) {
        // Pokud je jen jedna area, nastav jako default pro novy
        this.employee.area = this.listAreas[0].id;
      }
      this.$nextTick(function () {
        const form: any = this.$refs.employeeForm;
        form.validate();
      });
    },
    dataSave() {
      const form: any = this.$refs.employeeForm;
      if (form.validate() !== true) {
        this.$store.commit('globalMessage', this.$i18n.t('msg.formNotValid'));
      } else {
        if (this.employee.id === 0) {
          axios
            .post('/api/v1/employee', this.employee)
            .then((response) => {
              switch (response.data.status) {
                case 'recordExists':
                  this.$store.commit('globalMessage', this.$i18n.t('msg.identifierExists'));
                  break;
                case 'loginExists':
                  this.$store.commit('globalMessage', this.$i18n.t('msg.loginExists'));
                  break;
                case 'success':
                  this.$emit('newEmployeeID', response.data.newEmployeeID);
                  break;
                default:
                  this.$store.commit('globalMessage', `unknown status: ${response.data.status}`);
              }
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        } else {
          axios
            .put('/api/v1/employee', this.employee)
            .then((response) => {
              if (response.data.status === 'recordExists') {
                this.$store.commit('globalMessage', this.$i18n.t('msg.identifierExists'));
              } else if (response.data.status === 'loginExists') {
                this.$store.commit('globalMessage', this.$i18n.t('msg.loginExists'));
              } else {
                this.$emit('closeDialog', true);
                this.$emit('newEmployeeID', this.employee.id);
                this.dialogEdit = false;
              }
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        }
      }
    },
    listEmployeeGroupsLoad() {
      axios
        .get('/api/v1/employeegroup')
        .then((response) => {
          const global = response.data // Zmaz globalni skupinu pro planovani
            .map((item: any) => {
              return item.id;
            })
            .indexOf(0);
          response.data.splice(global, 1);
          this.listEmployeeGroups = response.data;
          for (const row of this.listEmployeeGroups) {
            row.displayName =
              row.name +
              ' (' +
              this.$i18n.t('label.planning') +
              ': ' +
              (row.planners.length > 0 ? this.$i18n.t('label.yes') : this.$i18n.t('label.no')) +
              ' - ' +
              this.$i18n.tc('label.approval') +
              ': ' +
              (row.authorisers.length > 0 ? this.$i18n.t('label.yes') : this.$i18n.t('label.no')) +
              ')';
          }
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    listAreasLoad() {
      axios
        .get('/api/v1/area')
        .then((response) => {
          for (const areaIncluded of this.$store.state.auth.wPlaceSettings.areas) {
            for (const area of response.data) {
              if (areaIncluded === area.id) {
                this.listAreas.push(area); // Napln listbox podla povolenych objektov
              }
              if (this.employee.area === 0 && area.id === this.$store.state.auth.wPlaceSettings.defaultarea) {
                this.employee.area = area.id; // Prednastav vychozi objekt
              }
            }
          }
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    genOrgID() {
      this.employee.orgID =
        (this.employee.surname.substring(0, 3) + this.employee.name.substring(0, 3)).normalize('NFD').replace(/[\u0300-\u036f]/g, '') +
        Math.floor(1000 + Math.random() * 9000);
    },
  },
});
</script>
